var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWallet28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11958_5845)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.79683 13.4813C3.42847 14.3008 3.42847 15.2937 3.42847 17.2796V21.6796C3.42847 24.1768 3.42847 25.4254 3.93883 26.3626C4.38169 27.1757 5.1092 27.8395 5.95944 28.2062C6.93929 28.6288 8.16148 28.5167 10.6059 28.2923C12.4583 28.1223 14.3838 27.9286 15.9999 27.7293C18.1383 27.4656 20.7597 27.0611 23.0544 26.6854C24.9814 26.37 25.9448 26.2122 26.6942 25.7161C27.3467 25.2841 27.8818 24.6542 28.2027 23.9405C28.5713 23.1208 28.5713 22.1273 28.5713 20.1403V15.7393C28.5713 13.2435 28.5713 11.9956 28.0612 11.0586C27.6186 10.2457 26.8912 9.58179 26.0414 9.21501C25.0619 8.79226 23.8406 8.90388 21.398 9.12711C19.5443 9.29652 17.6172 9.48989 15.9999 9.6893C13.8604 9.95311 11.2372 10.3588 8.94158 10.7356C7.01621 11.0517 6.05353 11.2097 5.30451 11.706C4.65247 12.1379 4.11749 12.7679 3.79683 13.4813ZM8.66656 21.695C9.82373 21.695 10.7618 20.7569 10.7618 19.5998C10.7618 18.4426 9.82373 17.5045 8.66656 17.5045C7.50939 17.5045 6.57132 18.4426 6.57132 19.5998C6.57132 20.7569 7.50939 21.695 8.66656 21.695Z",
    fill: "url(#paint0_linear_11958_5845)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.48376 8.58411C4.97305 8.36526 5.46111 8.21666 5.93291 8.10092C6.62866 7.93025 7.456 7.79451 8.33487 7.65032L8.43225 7.63434C10.7398 7.25556 13.4122 6.84175 15.6151 6.57013C17.28 6.36483 19.2446 6.16799 21.1117 5.99736L21.2278 5.98674C22.3492 5.88417 23.3833 5.78958 24.2554 5.78605C25.201 5.78223 26.2379 5.87691 27.2865 6.3295C27.432 6.39228 27.5752 6.45985 27.716 6.53199C27.4131 6.13474 27.0397 5.78865 26.6227 5.52454C25.8474 5.03345 24.8629 4.90135 22.8938 4.63714C20.7846 4.35413 18.4405 4.06668 16.5234 3.90056C14.9545 3.76463 13.0879 3.65936 11.2981 3.57945C8.97828 3.47589 7.81838 3.4241 6.88129 3.86528C6.07132 4.2466 5.37533 4.91221 4.95826 5.70436C4.59891 6.3869 4.50718 7.22063 4.48376 8.58411Z",
    fill: "url(#paint1_linear_11958_5845)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11958_5845",
    x1: 3.42847,
    y1: 3.50803,
    x2: 28.4119,
    y2: 28.6504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EC7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8AE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11958_5845",
    x1: 3.42847,
    y1: 3.50803,
    x2: 28.4119,
    y2: 28.6504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EC7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8AE6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11958_5845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet28);
export default __webpack_public_path__ + "static/media/wallet_28.b7bf93c7.svg";
export { ForwardRef as ReactComponent };